import React from 'react'
import LetterAvatar from './LetterAvatar'

const LetterAvatarUsage = () => {
    // Example user data
    const users = [
        { id: 1, name: 'John Doe', email: 'john@example.com' },
        { id: 2, name: 'Jane Smith', email: 'jane@example.com' },
        { id: 3, name: 'Mike Johnson', email: 'mike@example.com' },
        { id: 4, name: 'Sarah Wilson', email: 'sarah@example.com' },
        { id: 5, name: 'David Brown', email: 'david@example.com' }
    ]

    return (
        <div className="col-xxl-6">
            <div className="card p-0 overflow-hidden position-relative radius-12">
                <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                    <h6 className="text-lg mb-0">Letter Avatar Usage Examples</h6>
                </div>
                <div className="card-body p-24">
                    <div className="d-flex flex-column gap-3">
                        {users.map((user) => (
                            <div key={user.id} className="d-flex align-items-center gap-3 p-3 border rounded">
                                <LetterAvatar letter={user.name} size="40px" />
                                <div>
                                    <h6 className="mb-1">{user.name}</h6>
                                    <small className="text-muted">{user.email}</small>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        <h6 className="mb-3">Simple Usage:</h6>
                        <div className="d-flex align-items-center gap-3">
                            <LetterAvatar letter="A" />
                            <span>Default 40px avatar with letter "A"</span>
                        </div>
                        <div className="d-flex align-items-center gap-3 mt-2">
                            <LetterAvatar letter="B" size="60px" bgColor="bg-success-500" />
                            <span>Custom size and color</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LetterAvatarUsage 